import {userManager} from "../user/user-manager";

class Credits {
    async getActiveCost(costs, target = null) {
        let productIds = await this.getProductIds();
        let normalCosts =  costs.filter(v => v.type !=='default' && v.type !== 'target');

        if (target !== null) {
            normalCosts =  costs.filter(v => v.type !=='default' && v.type === 'target' && v.name === target);
        }

        for (let cost of normalCosts) {
            if (this.isCostIncluded(cost,productIds)) {

                return cost;
            }
        }

        for (let cost of normalCosts) {
            if (this.isCostExcluded(cost,productIds) === false && cost.included.length === 0) {

                return cost;
            }
        }


        return await this.getDefaultCost(costs, productIds);
    }

    getDefaultCost(costs, productIds) {
        let defaultCosts = costs.filter(v => v.type ==='default');

        for (let cost of defaultCosts) {
            if (this.isCostIncluded(cost,productIds)) {

                return cost;
            }
        }

        for (let cost of defaultCosts) {
            if (this.isCostExcluded(cost,productIds) === false && cost.included.length === 0) {

                return cost;
            }
        }

        if (Array.isArray(costs)) {

            return costs.filter(v => v.type ==='default')[0];
        }

        return null;
    }

    isCostExcluded(cost, productIds) {
        if (cost.excluded === null) {
            return false;
        }
        return cost.excluded.some(r => productIds.includes(parseInt(r)))
    }

    isCostIncluded(cost, productIds) {
        if (cost.included === null) {
            return false;
        }
        return cost.included.some(r => productIds.includes(parseInt(r)))
    }

    async getProductIds() {
        this.user = await userManager.getUser();
        return this.user.getProductIds();
    }
}

export default new Credits()